const googleMapsApiKey = "AIzaSyAJLsFBWyJmwXNQ6xkHWhWmk8_eSALtCYU";

export default googleMapsApiKey;